module.exports = __webpack_public_path__ + "img/20200917.4bd1824f.png";